module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/changing_denshokan-4820bcec7d335522beeb0fedd74cf7e8.jpg";